module.exports = __webpack_public_path__ + "img/2.556a1848.png";